module.exports = __webpack_public_path__ + "img/dp158_08.3f24b8ac.jpg";